import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtProjectGroup } from "server/models"
import { deepCopy } from "client/utils"
import {
    StoreType,
    setProjectPermissionsProjectGroupSelected,
} from "client/store"
import {
    UserIcon,
    TableColumn,
    DateFormatter,
} from "client/components"

const Columns = () => {
    const selected = useSelector((state: StoreType) => state.projectPermissions.projectGroups.selected)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const selectGroup = (group: MtProjectGroup) => {
        let selectedCopy
        if (selected && selected.includes(group.groupId)) {
            selectedCopy = selected.filter((id) => id !== group.groupId)
        } else {
            selectedCopy = selected ? deepCopy(selected) : []
            selectedCopy.push(group.groupId)
        }
        dispatch(setProjectPermissionsProjectGroupSelected(selectedCopy))
    }

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
            formatter: (group: MtProjectGroup) => group.groupId,
            onClick: selectGroup,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
            onClick: selectGroup,
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "300px",
            onClick: selectGroup,
        },
        {
            field: "creator",
            header: lang.createdBy,
            cellWidth: "200px",
            cellMinWidth: "200px",
            formatter: (group: MtProjectGroup) => {
                const user = userList[group.creator]
                return <UserIcon user={user} size="sm" />
            },
            onClick: selectGroup,
        },
        {
            field: "createdAt",
            header: lang.created,
            sortable: true,
            formatter: (group: MtProjectGroup) => <DateFormatter date={group.createdAt} />,
            onClick: selectGroup,
        },
    ]

    return columns
}
export default Columns
